'use client';

import { cn } from '@utils';
import { Button, ButtonProps } from 'react-aria-components';

export const HeaderNavButton = ({
	icon,
	label,
	...props
}: { icon: React.ReactNode; label: string } & ButtonProps) => {
	return (
		<Button
			{...props}
			className={cn(
				'border-dark-border border-l-1',
				'hover:bg-dark-background-shade light-focus cursor-pointer',
				'flex size-12 flex-col items-center justify-center text-center md:size-18',
				props.className,
			)}
		>
			{icon}
			<span className="text-dark-text mt-0.5 text-[0.625rem] leading-2 md:text-[0.875rem] md:leading-4">
				{label}
			</span>
		</Button>
	);
};
